export interface WarehouseChineseHoliday {
  city: string;
  begin: string;
  end: string;
}

export const receivingWarehouseChineseHolidays: WarehouseChineseHoliday[] = [
  {
    city: 'SHANGHAI',
    begin: '2023-01-21',
    end: '2023-01-23',
  },
  {
    city: 'GUANGDONG',
    begin: '2023-01-13',
    end: '2023-01-27',
  },
  {
    city: 'SHENZHEN',
    begin: '2023-04-26',
    end: '2023-05-03',
  },
];
